<!-- 查询注册用户绑定车辆接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "phone": "18000000000",
                "userId": 2,
            },
            responseCode: {
                "data": {
                    "carNo":"粤A12345"
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,查询注册用户绑定车辆",
                t_url: this.commonUrls.test+"getEnrollUserBindingCar",
                p_url: this.commonUrls.prod+"getEnrollUserBindingCar",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userId', info2: '否', info3: 'Long', info4: '智慧停车用户ID。phone和userId二者必填一个' },
                        { info1: 'phone', info2: '否', info3: 'String', info4: '注册用户手机号码。phone和userId二者必填一个' },
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carList', info2: '是', info3: 'JSONObject', info4: '车牌信息列表' },
                        ]
                },{
                    titleName: 'carList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'bindingDate', info2: '是', info3: 'String', info4: '绑定时间, yyyyMMddHHmmss' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '状态，0绑定 1删除 2认证 3被他人认证' },
                        { info1: 'default', info2: '是', info3: 'Integer', info4: '是否为默认车牌号码。0否 1是缺省车牌' },
                        { info1: 'authDate', info2: '否', info3: 'String', info4: '认证时间, yyyyMMddHHmmss' },
                        { info1: 'authLevel', info2: '是', info3: 'Integer', info4: '认证级别：0未认证，1缴费认证，2行驶证认证，3实名认证' },
                        { info1: 'isAllowOtherPay', info2: '是', info3: 'Integer', info4: '是否允许他人查询：0否，1是' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getEnrollUserBindingCar.vue